import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PortalProducts } from '@shared/enumeration';
import { PhysicianAccountPgpsDTO, TableColumn } from '@mynexus/mynexus-ui-lib';
import { SelectItem } from 'primeng/api';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'ordering-provider-select',
    templateUrl: './ordering-provider-select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrderingProviderSelectComponent implements OnChanges, OnInit {
  @Input() product: PortalProducts.PACIM | PortalProducts.PacCommercial;
  @Input() providers: PhysicianAccountPgpsDTO[] = [];

  @Output() selected = new EventEmitter<PhysicianAccountPgpsDTO>();

  cols: TableColumn[];
  providersList!: SelectItem<PhysicianAccountPgpsDTO>[];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['providers'] && this.product === PortalProducts.PACIM) {
      this.getProviderList();
    }
  }

  ngOnInit(): void {
    this.cols = [
      new TableColumn('Ordering Provider Name', 'accountName'),
      new TableColumn('Address', 'physicalStreet'),
      new TableColumn('City', 'physicalCity'),
      new TableColumn('State', 'physicalState'),
      new TableColumn('ZIP Code', 'physicalZip'),
      new TableColumn('Phone', 'phone'),
    ];
  }

  selectProvider(provider: PhysicianAccountPgpsDTO) {
    this.selected.emit(provider);
  }

  private getProviderList(): void {
    this.providersList = this.providers.map(provider => {
      const { accountName, physicalStreet, physicalCity, physicalState, physicalZip, phone } = provider.physicianAccountDTO;

      return {
        value: provider,
        label: `${accountName}, ${physicalStreet}, ${physicalCity} ${physicalState} ${physicalZip}, phone #:${phone}`
      }
    });
  }
}
